import React, { useRef, useState } from 'react';

import Flex from '../Flex';
import Text from '../Text';
import Tooltip from '../Tooltip';
import { ReactComponent as CopyIcon } from 'images/icons/copy.svg';

export default function Copy({ value = '', children = null }) {
  const [isCopied, setIsCopied] = useState(false);
  const timerRef = useRef(null);

  const onCopy = () => {
    navigator.clipboard.writeText(value);
    setIsCopied(true);
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsCopied(false), 1000);
  };

  return (
    <Flex inline align="center" gap={4}>
      {children}
      <Tooltip>
        <Tooltip.Trigger>
          <Text type="span" tone="link" onClick={onCopy}>
            <CopyIcon />
          </Text>
        </Tooltip.Trigger>
        <Tooltip.Content>{isCopied ? 'Copied' : 'Copy'}</Tooltip.Content>
      </Tooltip>
    </Flex>
  );
}
